module.exports = __webpack_public_path__ + "img/MX-B055046A-BS-HQ.4c61d21d.png";